import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const CSV_FILETYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

function csvExport(dataArray: any, fileName: string) {
  const ws = XLSX.utils.json_to_sheet(dataArray);
  const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: CSV_FILETYPE });
  FileSaver.saveAs(data, fileName);
}

export { csvExport };
